import React, { useState } from 'react'
import classNames from 'classnames'
import whatInput from 'what-input'

type Props = {
  label: React.ReactNode
  checked: boolean
  className?: string
  uid?: string
  name: string
  id: string
  value?: string
  type?: string
  onChange: (event) => void
}
const RadioButton = ({ label, className, uid, ...props }: Props) => {
  const [hasFocus, setFocus] = useState(false)
  const showFocusStyle = hasFocus && whatInput.ask() !== 'mouse'

  return (
    <label
      className={classNames('flex-column flex', 'items-center', className)}
      data-uid={uid}
    >
      <div
        className={classNames(
          'w-24',
          'h-24',
          'rounded-full',
          'border-2 border-LSBrand',
          {
            'border-blue': showFocusStyle,
          },
          'flex',
          'items-center',
          'justify-center',
          'mr-8',
        )}
      >
        <span
          className={classNames('rounded-full transition', {
            'bg-LSBrand': props.checked,
            'bg-white': !props.checked,
          })}
          style={{ width: 18, height: 18 }}
        />
      </div>
      <input
        type="radio"
        className="sr-only"
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        {...props}
      />
      <span className="mt-[4px] type-17">{label}</span>
    </label>
  )
}

export default RadioButton
